import { render, staticRenderFns } from "./ForecastViolationsDialog.vue?vue&type=template&id=60d856c0&scoped=true&"
import script from "./ForecastViolationsDialog.vue?vue&type=script&lang=js&"
export * from "./ForecastViolationsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d856c0",
  null
  
)

export default component.exports